"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsonpath_1 = require("@f5io/jsonpath");
const configStore_1 = require("./configStore");
function getItem(path) {
    return jsonpath_1.default(path, configStore_1.configStore);
}
exports.getItem = getItem;
